/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/layout/Page";
import { useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Stats from "../SavedJobs/Components/Stats";
import { Spin, Table, Tag, Space, Button as AntButton, Tooltip, Menu, Dropdown } from "antd";
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { FaEllipsisV } from '@react-icons/all-files/fa/FaEllipsisV';
import { setModalState, triggerResumeEditor } from "../../store/reducers/Modal/actions";
import moment from 'moment';
import { updateResume } from "../../store/reducers/Auth/actions";
import { getFriendlyTime } from "../../services/textService";
import { FaPlusCircle } from '@react-icons/all-files/fa/FaPlusCircle';
import { push } from "connected-react-router";

import "./index.scss";

export default props => {
    const location = useLocation();
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    // Format date for display
    const formatDate = (date) => {
        return moment(date).format('MM/DD/YYYY');
    };

    const onUpdateResume = async (resume, key, value) => {
        const formData = { _id: resume._id, [key]: value }
        dispatch(updateResume(formData))
    }
    const currentDate = moment().format('MM/DD/YYYY');

    // Define table columns
    const columns = [
        {
            title: 'Resume Title',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => (
                <div className="resume-title-cell">
                    <span className="resume-title">{text || `Resume (${record.key + 1})`}</span>
                    {record.isPrimary && <Tag color="blue">Base Resume</Tag>}

                </div>
            ),
        },
        {
            title: 'Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: () => getFriendlyTime(currentDate), // Using current date as shown in reference image
            sorter: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
            defaultSortOrder: 'descend',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => {
                const menuActions = [{ key: 'base', label: 'Set base menu', onClick: () => onUpdateResume(record.resume, 'isPrimary', true) }]
                    .filter(item => {
                        if (item.key === 'base' && record.isPrimary) return false
                        return true;
                    })
                return (
                    <Space size="middle">
                        <Tooltip title="Edit Resume">
                            <AntButton
                                type="text"
                                icon={<FaEdit />}
                                className="editor-btn"
                                onClick={() => onResumeClick(record)}
                            >
                                Editor
                            </AntButton>
                        </Tooltip>
                        {menuActions.length > 0 && <Dropdown menu={{
                            items: menuActions
                        }}>
                            <FaEllipsisV />
                        </Dropdown>}

                    </Space>
                )
            },
        },
    ];

    const onResumeClick = (record) => {
        // dispatch(setModalState('isResumeEditorModalOpen', true, { resume: record.resume }))
        dispatch(triggerResumeEditor({ resume: record.resume }))
    }

    // Prepare data for the table
    const getTableData = () => {
        if (!userDetails || !userDetails.resumeFiles) return [];

        return userDetails.resumeFiles.map((resume, index) => ({
            key: index,
            title: resume.title || `${resume.firstName || ''} ${resume.lastName || ''}`.trim() || `Resume (${index + 1})`,
            isPrimary: resume.isPrimary,
            date: currentDate, // Using current date as shown in reference image
            resume: resume
        }));
    };

    return (
        <Page className="resumes-page">
            <Stats />
            <div className="resume-page-header">
                <div>
                    <h1 style={{ display: 'flex', alignItems: 'center' }}>
                        <div>My Resumes</div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10, marginTop: 5 }}
                        onClick={() => dispatch(push('/resume-builder/create', { from: location.pathname }))}
                        >
                            <FaPlusCircle style={{ fontSize: 24 , color: '#4a4ade', cursor: 'pointer' }} />
                        </div>
                    </h1>
                    <p className="subtitle">View, share and edit your resumes here.</p>
                </div>
        
            </div>

            {loading ? (
                <div className="loading-container">
                    <Spin size="large" />
                </div>
            ) : (
                <div className="resume-table-container">
                    <Table
                        columns={columns}
                        dataSource={getTableData()}
                        pagination={false}
                        className="resume-table"
                        rowClassName={(record) => record.isPrimary ? 'primary-resume-row' : ''}
                    />
                </div>
            )}
        </Page>
    );
};